import {
  ChangeDetectionStrategy,
  Component,
  Input
} from "@angular/core";
import {LocationType} from "../../../../commons/types/location.type";

require('./oms-orders-table-row-task.scss');
@Component({
  standalone: false,
  selector: 'app-oms-orders-table-row-task',
  templateUrl: './oms-orders-table-row-task.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OmsOrdersTableRowTaskComponent {

  @Input() task: any;
  @Input() columns: any;

  public locationTypes: typeof LocationType = LocationType;

  constructor() {
  }

}
